import { readable } from "svelte/store";
import type { FacetValue } from "./FacetValue";

export const createFacetValuesStore = (facetValues: FacetValue[] | null | undefined) =>
  readable<FacetValue[]>(facetValues || []);
